import ApiService from '../api-service/ApiService';

const AI_STRATEGY_BASE_URL = '/ai-strategy';

const AIStrategyService = {
    // Generate personas using AI
    generatePersonas: (data) =>
        ApiService.postData(`${AI_STRATEGY_BASE_URL}/generate-personas`, data),

    // Get all strategies
    getStrategies: (activeOnly = false) =>
        ApiService.getData(`${AI_STRATEGY_BASE_URL}/list?activeOnly=${activeOnly}`),

    // Get single strategy by ID
    getStrategy: (id) =>
        ApiService.getData(`${AI_STRATEGY_BASE_URL}/${id}`),

    // Update strategy
    updateStrategy: (id, data) =>
        ApiService.putData(`${AI_STRATEGY_BASE_URL}/update/${id}`, data),

    // Delete strategy
    deleteStrategy: (id) =>
        ApiService.deleteData(`${AI_STRATEGY_BASE_URL}/delete/${id}`),

    // Activate strategy
    activateStrategy: (id) =>
        ApiService.putData(`${AI_STRATEGY_BASE_URL}/activate/${id}`, {}),
};

export default AIStrategyService;
